// extracted by mini-css-extract-plugin
export default {"root":"StoreClusterDetailPage_root__qSAOV"};